<template>
  <v-container grid-list-sm text-xs-center>
    <v-layout row wrap>
      <v-flex xs11>
        <form autocomplete="off">
          <v-layout row wrap align-center>
            <v-flex sm3 subheading>Name: </v-flex>
            <v-flex sm9>
              <v-text-field v-model="name" label="Name" required @blur="$v.name.$touch()" @input="$v.name.$touch()" :error-messages="nameErrorMsgs"></v-text-field>
            </v-flex>
            
            <v-flex sm3 subheading>Description: </v-flex>
            <v-flex sm9>
              <v-text-field v-model="description" label="Description" required @blur="$v.description.$touch()" @input="$v.description.$touch()" :error-messages="descriptionErrorMsgs"></v-text-field>
            </v-flex>
            
            <v-flex sm3 subheading>Users: </v-flex>
            <v-flex sm9>
              <v-autocomplete :items="allUsers" v-model="userIds" label="Select" item-text="firstName" item-value="id" multiple chips :menu-props="{maxHeight:'auto'}">
                <template slot="selectedUsers" slot-scope="data">
                  <v-chip :selected="data.userIds" :key="JSON.stringify(data.item)" close class="chip--select-multi" @input="data.parent.selectItem(data.item)">
                    {{ data.item.firstName }} {{ data.item.lastName }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.firstName + ' ' + data.item.lastName"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.email"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          
          <v-btn @click.stop="submit">Submit</v-btn>
          <v-btn @click="cancel">Cancel</v-btn>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
.full-width{
  width: 100%
}
</style>

<script>
import vh, {name, description} from '@/helpers/validators'
import axios from 'axios'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  props: ['id'],
  data () {
    return {
      name: '',
      description: '',
      userIds: [],
      users: []
    }
  },
  validations: {
    name: vh.vrules(name),
    description: vh.vrules(description)
  },
  computed: {
    ...mapGetters({
      getRoleById: 'getRoleById',
      getUserById: 'getUserById',
      allUsers: 'getUsers'
    }),
    nameErrorMsgs () {
      if (this.$v.name.$dirty) {
        return vh.vmsg(this.$v.name, name)
      } else {
        return []
      }
    },
    descriptionErrorMsgs () {
      if (this.$v.description.$dirty) {
        return vh.vmsg(this.$v.description, description)
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapActions({ addRole: 'addRole' }),
    getData () {
      axios.all([this.$store.dispatch('getUsers')]).then(axios.spread((usersResponse) => {
        if (usersResponse.data.status === 'SUCCESS') {
          this.$store.commit('setUsers', usersResponse.data.payload)
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.submitData()
    },
    submitData () {
      this.users = []
      for (var i = 0; i < this.userIds.length; i++) {
        this.users.push(this.getUserById(this.userIds[i]))
      }

      if (!this.id) {
        axios.all([this.$store.dispatch('addRole', {name: this.name, description: this.description, users: this.users})]).then(axios.spread((r) => {
          if (r.data.status === 'SUCCESS') {
            this.$store.commit('addRole', r.data.payload)
            this.$router.push('./')
          } else {
            this.notify({message: 'Something went wrong while sending data.', show: true})
          }
        })).catch((err) => {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      } else {
        axios.all([this.$store.dispatch('updateRole', {id: Number(this.id), name: this.name, description: this.description, users: this.users})]).then(axios.spread((r) => {
          if (r.data.status === 'SUCCESS') {
            this.$store.commit('updateRole', r.data.payload)
            this.$router.push('./')
          } else {
            this.notify({message: 'Something went wrong while sending data.', show: true})
          }
        })).catch((err) => {
          this.notify({message: 'Something went wrong while connecting to the server', show: true})
          console.log(err)
        })
      }
    },
    cancel () {
      this.$router.push('./')
    }
  },
  mounted: function () {
    this.getData()
  },
  created () {
    if (!this.id) {
      return
    }

    const role = this.getRoleById(this.id)

    if (!role) {
      this.$router.push('./')
      return
    }

    this.name = role.name
    this.description = role.description
    this.users = role.users
    this.userIds = []
    for (var i = 0; i < this.users.length; i++) {
      this.userIds.push(Number(this.users[i].id))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/roles/Role.vue